import React, { useState } from 'react';
import { ArrowDownIcon, CheckIcon } from 'lucide-react';
import { selector } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function PackSelector() {
  const [active, setActive] = useState(0);
  const item = selector.items[active];
  const cols = [item.consent, item.guide, item.patient];
  function goToPacks(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    document.getElementById('packs')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  return <section aria-labelledby="selector-title" className="bg-cream py-12 md:py-20" data-id="element-163" data-mp="1i3xbl4vpv76k">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-164" data-mp="1dbcn8ivkxmaf">
        <SectionHeading id="selector-title" eyebrow={selector.eyebrow} title={selector.title} sub={selector.sub} data-id="element-165" data-mp="19bbxi2315oo2" />

        <div role="tablist" aria-label="Treatments" className="mt-8 grid grid-cols-2 gap-2 md:mt-10 md:flex md:justify-center" data-id="element-166" data-mp="25thvpr3lwahf">
          {selector.items.map((it, i) => {
          const on = i === active;
          return <button key={it.tab} role="tab" type="button" aria-selected={on} aria-controls="selector-panel" onClick={() => setActive(i)} className={`min-h-[48px] rounded-lg border px-4 text-[15px] font-semibold transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange ${on ? 'border-teal bg-teal text-white' : 'border-cream-line bg-white text-teal hover:border-teal'}`} data-id="element-167" data-mp="fk6jt2u5g94t" data-mpi={i}>
                {it.tab}
              </button>;
        })}
        </div>

        <div id="selector-panel" role="tabpanel" className="mx-auto mt-6 max-w-[960px] rounded-2xl border border-cream-line bg-white p-5 md:p-8" data-id="element-168" data-mp="3nzq77l852xby">
          <p className="font-display text-[12px] font-extrabold tracking-[0.12em] text-orange-ink" data-id="element-169" data-mp="1m8mumqeov8or">{item.n}</p>
          <h3 className="mt-1 font-display text-[22px] font-extrabold uppercase tracking-tight text-teal md:text-[26px]" data-id="element-170" data-mp="1kr7otlm2f0zc">{item.tab}</h3>

          <div className="mt-6 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-171" data-mp="1fqjr6h3bzlw5">
            {cols.map((list, c) => <div key={selector.columns[c]} className="rounded-xl bg-teal-tint p-4 md:p-5" data-id="element-172" data-mp="1auumy0gd9gti" data-mpi={c}>
                <h4 className="font-display text-[13px] font-extrabold tracking-[0.1em] text-teal" data-id="element-173" data-mp="16szpx85gxplj">{selector.columns[c]}</h4>
                <ul className="mt-3 space-y-2.5" data-id="element-174" data-mp="1yichg3r0mt06">
                  {list.map(line => <li key={line} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-175" data-mp="1ykp1cmgc3dfv">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal text-white" data-id="element-176" data-mp="1tp9onxu2bnl1">
                        <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-177" data-mp="2m8go6jzi38ve" />
                      </span>
                      {line}
                    </li>)}
                </ul>
              </div>)}
          </div>

          <a href="#packs" onClick={goToPacks} className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-teal underline-offset-4 hover:underline" data-id="element-178" data-mp="40x5p4axsztt">
            {selector.more}
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-179" data-mp="hylpe8t9q0xa" />
          </a>
        </div>
      </div>
    </section>;
}